<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
      <i class="el-icon-s-fold" ></i>
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item >内容管理</el-breadcrumb-item>
        <el-breadcrumb-item >耗材管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

      <!-- 耗材分布 -->
      <div class="equipment-distribution" v-if="showConsInventory==true">
         <!-- <dv-border-box-12 style="padding: 6px 0px 6px 6px;"> -->
         <div class="header-common">
           <div class="header-common-left">
             <div class="title">使用单位耗材剩余统计</div>
           </div>
           <div class="header-common-right">
             <el-button
               class="right-button-export"
               @click="exportTable(1)"
               type="text"
               >
               导出
             </el-button>
           </div>
         </div>
         <div class="distribution-list">
           <el-table
            v-loading='loading1'
             :data="hospitalsData"
             :max-height="215"
              border
             :cell-style="tableCellStyle"
             :header-cell-style="tableHeaderCellStyle"
              @cell-click="showMoreDetailConsumables"
             >
             <el-table-column
               type="index"
               label="序号">
             </el-table-column>
             <el-table-column
               prop="provinceName"
               label="所在地区">
             </el-table-column>
             <el-table-column
               prop="name"
               label="使用单位"
               >
             </el-table-column>
             <el-table-column
               prop="amount"
               label="耗材剩余"
               sortable>
             </el-table-column>
           </el-table>
         </div>
         <!-- </dv-border-box-12> -->
       </div>

      <!-- 2.耗材列表 -->
      <!-- 2.1 -->
      <div class="tabs-content">
          <div>
            <div style="">
              <el-tabs
              type="border-card"
              style="background-color: transparent;border: 1px solid #1A3F81;border-radius: 12px;"
              v-model="activeName"
              @tab-click="handleClick"
              class="tabs-style"
              >
                <el-tab-pane name="consCompany" v-if="showConsInventory == true">
                  <span slot="label"><i class="el-icon-date"></i> 耗材库存记录</span>
                  <div class="list-used">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">耗材库存记录</div>
                        </div>
                        <div class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportTable(2)"
                            type="text"
                            >
                            导出
                          </el-button>
                          <router-link v-if="showActionAdd==true" class="right-button-base" :to="{path:'/manage/consumables/consumables-add'}">
                            耗材入库
                          </router-link>
                          <router-link v-if="showActionAdd==true" class="right-button-base" :to="{path:'/manage/consumables/consumables-edit'}">
                            耗材出库
                          </router-link>
                        </div>
                      </div>
                      <div >
                        <div class="condition">
                            <el-date-picker
                                  v-model="value1"
                                  name="s1"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="入库日期范围开始"
                                  end-placeholder="入库日期范围结束"
                                  style="background-color: #fff;"
                                  popper-class="dateranges"
                                  label="入库日期范围"
                                  placeholder="选择入库开始和结束日期"
                                  :picker-options="pickerOptions"
                                  @change="handlechange">
                            </el-date-picker>
                            <input id="search_type1" v-model="search_type" type="text" autocomplete="off" placeholder="产品名称或规格型号" class="el-input__inner" style="background-color: #fff;color: #333;width: 15%;">
                            <input id="search_udi1" v-model="search_udi" type="text" autocomplete="off" placeholder="UDI" class="el-input__inner" style="background-color: #fff;color: #333;width: 15%;">
                            <el-button
                              type="text"
                              size="medium"
                              class="action-button-search"
                              @click="searchContent()"
                              >
                              <i class="el-icon-search" size="medium"></i>
                            </el-button>
                        </div>
                        <!-- :data="tableData.filter(data => !search1 || data.entranceDate.toLowerCase().includes(search.toLowerCase()) || data.udi.toLowerCase().includes(search.toLowerCase()) || data.type.toLowerCase().includes(search.toLowerCase()))" -->

                        <el-table
                          v-loading='loading2'
                          border
                          default-expand-all
                          border
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          :data="tableData.filter(data => !search1 || data.entranceDate.toLowerCase().includes(search1.toLowerCase()) || data.udi.toLowerCase().includes(search1.toLowerCase()) || data.type.toLowerCase().includes(search1.toLowerCase()))"
                          >
                            <el-table-column
                              label="序号"
                              type="index"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="entranceDate"
                              label="入库日期"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="typeName"
                              label="产品名称">
                            </el-table-column>
                            <el-table-column
                              prop="typeModel"
                              label="规格型号">
                            </el-table-column>
                            <el-table-column
                              prop="udi"
                              label="UDI">
                            </el-table-column>
                            <el-table-column
                              label="状态"
                              >
                              <template>在库</template>
                            </el-table-column>
                            <el-table-column
                              style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                              label="操作"
                              >
                              <template slot="header" slot-scope="scope">
                                <el-input
                                  id="search1"
                                  v-model="search1"
                                  size="mini"
                                  placeholder="输入关键字搜索"/>
                              </template>
                              <template slot-scope="scope">
                                <router-link
                                v-if="showActionAdd==true"
                                class="action-button-base"
                                :to="{path:'/manage/consumables/consumables-edit',query:{udi:scope.row.udi}}">
                                  出库
                                </router-link>
                                <el-button
                                  v-if="showActionAdd==true"
                                  @click.native.prevent="deleteRow(scope.$index, scope.row)"
                                  type="text"
                                  size="small"
                                  style="background-color: #20478D;"
                                  class="action-button">
                                  删除
                                </el-button>
                              </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination
                          background
                          layout="prev, pager, next"
                          :page-size="PageSize"
                          :total="totalAmount"
                          :current-page="currentPage"
                          @current-change="changeCurrentPage"
                          @prev-click="prevClicvPage"
                          @next-click="nextClickPage"
                          style="margin-left: 15px;margin-top:10px;">
                        </el-pagination>
                      </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane style="background-color: transparent;" name="consUsed" v-if="showConsUsed==true">
                  <span slot="label"><i class="el-icon-date"></i> 耗材使用记录</span>
                  <div class="list-used">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">耗材使用记录</div>
                        </div>
                        <div class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportTable(3)"
                            type="text"
                            >
                            导出
                          </el-button>
                        </div>
                      </div>
                      <div >
                        <div class="condition">
                            <el-date-picker
                                  v-model="value1"
                                  name="s2"
                                  type="daterange"
                                  label="使用日期范围"
                                  placeholder="选择使用开始和结束日期"
                                  range-separator="至"
                                  start-placeholder="使用日期范围开始"
                                  end-placeholder="使用日期范围结束"
                                  style="background-color: #fff;"
                                  popper-class="dateranges"
                                  :picker-options="pickerOptions"
                                  @change="handlechange">
                            </el-date-picker>
                            <input id="search_hospital2" v-model="search_hospital" :clearable="true" type="text" autocomplete="off" placeholder="使用单位" class="el-input__inner" style="background-color: #fff;color: #333;width: 10%;">
                            <input id="search_type2" v-model="search_type" type="text" autocomplete="off" placeholder="产品名称或规格型号" class="el-input__inner" style="background-color: #fff;color: #333;width: 15%;">
                            <input id="search_udi2" v-model="search_udi" type="text" autocomplete="off" placeholder="UDI" class="el-input__inner" style="background-color: #fff;color: #333;width: 15%;">
                            <el-button
                              type="text"
                              size="medium"
                              class="action-button-search"
                              @click="searchContent()"
                              >
                              <i class="el-icon-search" size="medium"></i>
                            </el-button>
                        </div>
                        <el-table
                          v-loading='loading2'
                          row-key="id"
                          border
                          default-expand-all
                          border
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          :data="tableData.filter(data => !search2 || data.useDate.toLowerCase().includes(search2.toLowerCase()) || data.hospitalName.toLowerCase().includes(search2.toLowerCase()) || data.udi.toLowerCase().includes(search2.toLowerCase()) || data.type.toLowerCase().includes(search2.toLowerCase()))"

                          >

                            <el-table-column
                              type="index"
                              label="序号"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="shipDate"
                              label="出库日期"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="useDate"
                              label="使用日期"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="hospitalName"
                              label="使用单位"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="typeName"
                              label="产品名称">
                            </el-table-column>
                            <el-table-column
                              prop="typeModel"
                              label="规格型号">
                            </el-table-column>
                            <el-table-column
                              prop="udi"
                              label="UDI">
                            </el-table-column>
                            <el-table-column
                              prop="date_used"
                              label="状态"
                              >
                              <template slot="header" slot-scope="scope">
                                <el-input
                                  id="search2"
                                  v-model="search2"
                                  size="mini"
                                  placeholder="输入关键字搜索"/>
                              </template>
                              <template>已使用</template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                          background
                          layout="prev, pager, next"
                          :page-size="PageSize"
                          :total="totalAmount"
                          :current-page="currentPage"
                          @current-change="changeCurrentPage"
                          @prev-click="prevClicvPage"
                          @next-click="nextClickPage"
                        style="margin-left: 15px;margin-top:10px;">
                        </el-pagination>
                      </div>
                  </div>
                </el-tab-pane>
                  <el-tab-pane name="consHospital" v-if="showConsInventory==true">
                    <span slot="label"><i class="el-icon-date"></i> 使用单位耗材剩余</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">使用单位剩余耗材明细</div>
                          </div>
                          <div class="header-common-right">
                            <el-button
                              class="right-button-export"
                              @click="exportTable(4)"
                              type="text"
                              >
                              导出
                            </el-button>
                          </div>
                        </div>
                        <div >
                          <div class="condition">
                              <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="出库日期范围开始"
                                    end-placeholder="出库日期范围结束"
                                    name="s3"
                                    label="出库日期范围"
                                    placeholder="选择出库开始和结束日期"
                                    style="background-color: #fff;"
                                    popper-class="dateranges"
                                    :picker-options="pickerOptions"
                                    @change="handlechange">
                              </el-date-picker>
                              <input id="search_hospital3" v-model="search_hospital" type="text" autocomplete="off" placeholder="使用单位" class="el-input__inner" style="background-color: #fff;color: #333;width: 10%;">
                              <input id="search_type3" v-model="search_type" type="text" autocomplete="off" placeholder="产品名称或规格型号" class="el-input__inner" style="background-color: #fff;color: #333;width: 15%;">
                              <input id="search_udi3" v-model="search_udi" type="text" autocomplete="off" placeholder="UDI" class="el-input__inner" style="background-color: #fff;color: #333;width: 15%;">
                              <el-button
                                type="text"
                                size="medium"
                                class="action-button-search"
                                @click="searchContent()"
                                >
                                <i class="el-icon-search" size="medium"></i>
                              </el-button>
                          </div>

                          <!-- :data="tableData.filter(data => !search || data.hospitalName.toLowerCase().includes(search.toLowerCase()) || data.udi.toLowerCase().includes(search.toLowerCase()) || data.type.toLowerCase().includes(search.toLowerCase()))" -->

                          <!-- :data="tableData" -->
                          <el-table
                            v-loading='loading2'
                            row-key="id"
                            border
                            default-expand-all
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :max-height="tableHeight"
                            :data="tableData.filter(data => !search3 || data.hospitalName.toLowerCase().includes(search3.toLowerCase()) || data.udi.toLowerCase().includes(search3.toLowerCase()) || data.type.toLowerCase().includes(search3.toLowerCase()))"

                            >

                              <el-table-column
                                type="index"
                                label="序号"
                                >
                              </el-table-column>
                              <el-table-column
                                prop="shipDate"
                                label="出库日期">
                              </el-table-column>
                              <el-table-column
                                prop="hospitalName"
                                label="使用单位">
                              </el-table-column>
                              <el-table-column
                                prop="typeName"
                                label="产品名称">
                              </el-table-column>
                              <el-table-column
                                prop="typeModel"
                                label="规格型号">
                              </el-table-column>
                              <el-table-column
                                prop="udi"
                                label="UDI">
                              </el-table-column>
                              <el-table-column
                                prop="date_used"
                                label="状态"
                                >
                                <template slot="header" slot-scope="scope">
                                  <el-input
                                    id="search3"
                                    v-model="search3"
                                    size="mini"
                                    placeholder="输入关键字搜索"/>
                                </template>
                                <template>未使用</template>
                              </el-table-column>
                          </el-table>
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :page-size="PageSize"
                            :total="totalAmount"
                            :current-page="currentPage"
                            @current-change="changeCurrentPage"
                            @prev-click="prevClicvPage"
                            @next-click="nextClickPage"
                            style="margin-left: 15px;margin-top:10px;">
                          </el-pagination>
                        </div>
                    </div>
                  </el-tab-pane>
              </el-tabs>

            </div>
          </div>
      </div>
  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSimplifyConversionUtil} from '../../../utils/povince_handle.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '108px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },

        tableHeight:0,

        totalAmount:1,//总数量
        totalPageAmount:1 ,//总页数
        PageSize:100,
        currentPage:1,

        showActionAdd:false,//耗材出入库
        showConsMonitor:false,
        showConsUsed:false,
        showConsInventory:false,

        hospitalsData:[],//各医院的耗材分布情况
        loading1:false,

        tableData:[],
        loading2:false,
        activeName:'consCompany',

        search1:'',
        search2:'',
        search3:'',

        startPlaceHolder:'',
        endPlaceHolder:'',

        //搜索条件
        search_start_date:'',
        search_end_date:'',
        search_type:'',
        search_udi:'',
        search_status:'',
        search_hospital:'',
        value1: '',
        pickerOptions: {
          disabledDate: this.disabledDate
        },
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;text-align:left;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:left;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },

      // click单元格时显示某医院耗材详情
      showMoreDetailConsumables(row, column, cell, event){
        this.$router.push({
          path: '/manage/consumables/consumables-hospital-list',
          query: {
            id: row.id,//医院id
          }
        })
      },
      // 各大医院库存
      getListOfHospitalInventory(){
        this.loading1 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/consumable/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading1 = false
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.hospitals){

                // 获取公司库存数据
                this.hospitalsData = obj.data.hospitals;
                areaSimplifyConversionUtil.codeToName(this.hospitalsData);
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading1 = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      changeCurrentPage(page){
        this.currentPage = page
        if (this.activeName == 'consUsed') {
          this.getListOfUsed()
        } else if (this.activeName == 'consHospital'){
          this.getListOfUnused()
        }else{
          this.getListOfInventory();
        }
      },
      prevClicvPage(page){
        this.currentPage = page
        if (this.activeName == 'consUsed') {
          this.getListOfUsed()
        } else if (this.activeName == 'consHospital'){
          this.getListOfUnused()
        }else{
          this.getListOfInventory();
        }
      },
      nextClickPage(page){
        this.currentPage = page
        if (this.activeName == 'consUsed') {
          this.getListOfUsed()
        } else if (this.activeName == 'consHospital'){
          this.getListOfUnused()
        }else{
          this.getListOfInventory();
        }
      },
      // 公司库存
      getListOfInventory(){
        this.loading2 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/list-unshipped';

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:{'page':this.currentPage,'size':this.PageSize}
        }).then(res=>{
          this.loading2 = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.consumables){
                // 获取公司库存数据
                this.tableData = obj.data.consumables;
                this.totalAmount = obj.data.totalAmount;
                this.totalPageAmount = obj.data.pageAmount;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading2 = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // 获取使用过的耗材
      getListOfUsed(){
        this.loading2 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/list-used';

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:{'page':this.currentPage,'size':this.PageSize}
        }).then(res=>{
          this.loading2 = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.consumables){
                this.tableData = obj.data.consumables;
                this.totalAmount = obj.data.totalAmount;
                this.totalPageAmount = obj.data.pageAmount;

              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading2 = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      //已出库但还未使用的耗材
      getListOfUnused(){
        this.loading2 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/list-unused-shipped';

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:{'page':this.currentPage,'size':this.PageSize}
        }).then(res=>{
          this.loading2  =false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.consumables){
                // 获取公司库存数据
                this.tableData = obj.data.consumables;
                this.totalAmount = obj.data.totalAmount;
                this.totalPageAmount = obj.data.pageAmount;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading2 = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleClick(tab, event){
        this.currentPage = 1;
        this.totalAmount = 1;
        this.totalPageAmount = 1;
        this.tableData = [];
        // this.value1 = ''
        this.search_start_date = '';
        this.search_end_date = '';
        this.search_hospital = '';
        this.search_type = '';
        this.search_udi = '';


        this.search1 = ''
        this.search2 = ''
        this.search3 = ''
        this.value1 = ''

        if (tab.name == 'consUsed') {
          this.getListOfUsed()
        } else if (tab.name == 'consHospital'){
          this.getListOfUnused()
        }else{
          this.getListOfInventory();
        }
      },
      judgePermissions(){
          let per1 = permissionCheckUtil.findName("consumable:create");
          let per2 = permissionCheckUtil.findName("consumable:readUsed");
          let per3 = permissionCheckUtil.findName("consumable:readInventory");
          let per4 = permissionCheckUtil.findName("consumable:alert");

          if(per1==true){
            this.showActionAdd = true;
          }

          if(per2==true){
            this.showConsUsed = true;
            this.activeName = "consUsed"
          }

          if(per3==true){
            this.showConsInventory = true;
            this.activeName = "consCompany"
          }

          if(per4==true){
            this.showConsMonitor = true;
          }
      },
      deleteRow(index,row) {
        this.$confirm('此操作将永久删除该耗材，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteRowAction(index,row.id);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消删除'
          })
        })
      },
      deleteRowAction(index,id){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/delete';
        const data = {"id":id}

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              // 注销成功
              this.tableData.splice(index,1);
              this.$message({
                type:'success',
                message:'已删除'
              })
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // 日期禁用
        disabledDate(time) {
          const date = new Date()
          return time.getTime() > date.getTime();
        },
        // 修改日期
        handlechange(val) {
          // val 返回格式为[Sun Jul 16 2023 00:00:00 GMT+0800 (中国标准时间), Fri Jul 21 2023 00:00:00 GMT+0800 (中国标准时间)]需转换年月日
          if(val == null){
            this.search_start_date = '';
            this.search_end_date = '';
          }else{
            this.search_start_date = this.formatDateTime(val[0]);
            this.search_end_date = this.formatDateTime(val[1]);
          }

          // this.timeAll = this.getAll(this.startTime, this.endTime); // 开始结束时间之间的每一天集合['2023-07-16', '2023-07-17', '2023-07-18']
        },
        // 中国标准时间 转换成 年月日
        formatDateTime (date) {
              var y = date.getFullYear();
              var m = date.getMonth() + 1;
              m = m < 10 ? ('0' + m) : m;
              var d = date.getDate();
              d = d < 10 ? ('0' + d) : d;
              var h = date.getHours();
              var minute = date.getMinutes();
              minute = minute < 10 ? ('0' + minute) : minute;
              return y + '-' + m + '-' + d;
         },
        // 获取开始结束时间之间的每一天
        getAll(start, end) {
             let dateList = [];
             var startTime = this.getDate(start);
             var endTime = this.getDate(end);
             while ((endTime.getTime() - startTime.getTime()) >= 0) {
                   var year = startTime.getFullYear();
                   var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
                   var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
                   dateList.push(year + "-" + month + "-" + day);
                   startTime.setDate(startTime.getDate() + 1);
             }
             return dateList;
        },
        // 搜索
        searchContent(){
          this.currentPage = 1;
          this.totalAmount = 1;
          this.totalPageAmount = 1;

          const headers = {
              'Authorization': localStorage.getItem('token')
          }
          const url = '/consumable/search';

          var params = {};
          var status = 1;
          if(this.activeName == 'consCompany'){
            status = 1;
            params = {
              "page":this.currentPage,
              'size':this.PageSize,
              'status':status,
              'entranceDateStart':this.search_start_date,
              'entranceDateEnd':this.search_end_date,
              'type':this.search_type,
              'udi':this.search_udi,
              'hospitalName':this.search_hospital
            }
          }else if(this.activeName == 'consHospital'){
            status = 2;
            params = {
              "page":this.currentPage,
              'size':this.PageSize,
              'status':status,
              'shipDateStart':this.search_start_date,
              'shipDateEnd':this.search_end_date,
              'type':this.search_type,
              'udi':this.search_udi,
              'hospitalName':this.search_hospital
            }
          }else if(this.activeName == 'consUsed'){
            status = 3;
            params = {
              "page":this.currentPage,
              'size':this.PageSize,
              'status':status,
              'useDateStart':this.search_start_date,
              'useDateEnd':this.search_end_date,
              'type':this.search_type,
              'udi':this.search_udi,
              'hospitalName':this.search_hospital
            }
          }


          this.$http({
            method:'GET',
            url:url,
            headers:headers,
            params:params
          }).then(res=>{
            if(res.status == 200){//请求成功
            var obj = res.data;
              if(obj.code == 0){
                if(obj.data.consumables){
                  this.tableData = obj.data.consumables;
                  this.totalAmount = obj.data.totalAmount;
                  this.totalPageAmount = obj.data.pageAmount;
                }
              }else{
                this.$message.error(obj.message);
              }
            }else{
              this.$message.error(res.data.message);
            }
          }).catch(err=>{
            if(!err.response){
              this.$message.error(err.message);
            }else{
              this.$message.error(err.response.data.message);
            }
          })
        },
        exportTable(type){
          //1-医院耗材剩余统计;2-库存记录；3-使用记录，4-剩余记录
          var tableHeader = [];
          var dataList = [];
          var documentName = ''
          switch(type){
            case 1:{
              tableHeader = [['序号','所在地区','使用单位','耗材剩余']];
              documentName = '耗材剩余统计';
              this.hospitalsData.forEach((item,index)=>{
                dataList.push([
                  index+1,
                  item.provinceName,
                  item.name,
                  item.amount
                ]);
              });
            }
            break;
            case 2:{
              tableHeader = [['序号','入库日期','产品名称','规格型号','UDI','状态']];
              documentName = '耗材库存记录';
              this.tableData.forEach((item,index)=>{
                dataList.push([
                  index+1,
                  item.entranceDate,
                  item.typeName,
                  item.typeModel,
                  item.udi,
                  '未出库'
                ]);
              });
            }
            break;
            case 3:{
              tableHeader = [['序号','出库日期','使用日期','使用单位','产品名称','规格型号','UDI','状态']];
              documentName = '耗材使用记录';
              this.tableData.forEach((item,index)=>{
                dataList.push([
                  index+1,
                  item.shipDate,
                  item.useDate,
                  item.hospitalName,
                  item.typeName,
                  item.typeModel,
                  item.udi,
                  '已使用'
                ]);
              });
            }
            break;
            case 4:{
              tableHeader = [['序号','出库日期','使用单位','产品名称','规格型号','UDI','状态']];
              documentName = '耗材剩余明细';
              this.tableData.forEach((item,index)=>{
                dataList.push([
                  index+1,
                  item.shipDate,
                  item.hospitalName,
                  item.typeName,
                  item.typeModel,
                  item.udi,
                  '未使用'
                ]);
              });
            }
            break;
            default: this.$message('导出错误')
            break;
          }

          if(dataList.length > 0){
            dataConversionUtil.dataToExcel(documentName,tableHeader,dataList)
            this.$message.success('导出成功')
          }else{
            this.$message.warning('无数据导出')
          }

        },
        sizeFun(){
          this.$nextTick(() => {
            if(this.showConsMonitor == true){
              this.tableHeight = window.innerHeight-650 < 300 ? 300 : window.innerHeight-650
            }else{
              this.tableHeight = window.innerHeight-370 < 300 ? 300 : window.innerHeight-370
            }
          })
        }
    },
    created() {
      this.judgePermissions();
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()

      if (this.showConsInventory==true) {
        this.getListOfHospitalInventory()
        this.getListOfInventory()
      }
    }
  }
</script>


<style lang="scss" scoped>
.container{
  margin-top: $header-height;

  .equipment-distribution{

    display: flex;
    flex-direction: column;


    .distribution-list{
      // margin: 0px 0px 0px 6px;
      // padding-bottom: 10px;
    }
  }

  .tabs-content{
    margin-top: 15px;
    // $main-padding;

    .tabs-style{

    }


      .action-button{
        width: 89px;
        height: 31px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        // margin-right: 20px;
      }

      .action-button-search{
        width: 39px;
        margin-top:2px;
        // height: 40px;
        // background: #FAFAFA;
        // font-size: 14px;
        // font-weight: 400;
        color: #333;
        // margin-right: 20px;
        background-color:#fff;
        border-radius:0 50% 50% 0;
      }

      .action-button-base{
        width: 89px;
        height: 31px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        display: inline-block;
        line-height: 31px;
        text-align: center;
        text-decoration: none;
      }

    .table-content{



      .table-list{

      }
    }

  }

  // 公共头部样式

  .header-common{
    width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-right: 26px;

    .header-common-left{
      font-size: 20px;
      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
      .title{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
      }
    }
    .header-common-right{

      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }

      .right-button-base{
        width: 89px;
        height: 40px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        margin-right: 20px;
        display: inline-block;
        line-height: 40px;
        text-decoration: none;
        text-align: center;
      }
    }

    .condition{
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: pink;
      height: 40px;
      width: 100%;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/view/manage/consumables/consumables-list.vue